export default {"src":"/_next/static/media/hb-logo-blue.b6f423ce.svg","height":230,"width":683};